<template>
  <div>
    <el-container
      style="
        max-width: 1000px;
        min-width: 700px;
        margin: auto;
        height: calc(100vh - 120px);
      "
    >
      <el-aside style="width: 160px">
        <div style="height: 100%">
          <el-menu
            default-active="1"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            :router="true"
            style="height: 100%"
          >
            <el-menu-item index="1" route="/unit1">
              <span>装配式单梁模块</span>
            </el-menu-item>
            <el-menu-item index="2" route="/unit2">
              <span>装配式梁格模块</span>
            </el-menu-item>
            <el-menu-item index="3" route="/unit3">
              <span>装配式桥墩模块</span>
            </el-menu-item>
            <el-menu-item index="4" route="/unit4">
              <span>等高现浇箱梁模块</span>
            </el-menu-item>
            <el-menu-item index="5" route="/unit5">
              <span>变高现浇箱梁模块</span>
            </el-menu-item>
            <el-menu-item index="6" route="/unit6">
              <span>节段悬浇箱梁模块</span>
            </el-menu-item>
            <el-menu-item index="7" route="/unit7">
              <span>等高裤衩箱梁模块</span>
            </el-menu-item>
            <el-menu-item index="8" route="/road">
              <span>路线文件格式</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-aside>
      <el-main>
        <el-scrollbar height="100vh"> 
          <router-view></router-view>
        </el-scrollbar>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.query.id,
    };
  },
  methods: {
    handleOpen(key, route) {
      this.$router.push(route);
    },
    handleClose(key, route) {},
  },
};
</script>
